import { wealthProApi } from '../../redux/api';
import { useCacheKeyMergeHandler, useCacheKeySerializeQueryArgsHandler, useCacheKeyTransformResponseHandler } from "../../redux/helpers";

const buildDashboardLoginEventsQuery = ({ masterAccountId, masterAccountLoginId, page, limit, sort, searchTerm }) => {
    let baseQuery = `/api/clientauth/master-accounts/${masterAccountId}/dashboard/logins/${masterAccountLoginId}/events?page=${page}&limit=${limit}`;
    if (sort && sort.length > 0) {
        baseQuery += `&sort=${sort}`;
    }
    if (searchTerm && searchTerm.length > 0) {
        baseQuery += `&searchTerm=${encodeURIComponent(searchTerm)}`;
    }
    return baseQuery;
};

const buildEventsQuery = ({ page, limit, sort, searchTerm }) => {
    let baseQuery = `/api/clientauth/system/events?page=${page}&limit=${limit}`;
    if (sort && sort.length > 0) {
        baseQuery += `&sort=${sort}`;
    }
    if (searchTerm && searchTerm.length > 0) {
        baseQuery += `&searchTerm=${encodeURIComponent(searchTerm)}`;
    }
    return baseQuery;
};

const clientAuthEventEndpoints = wealthProApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchClientLoginEvents: builder.query({
            query: (props) => buildDashboardLoginEventsQuery(props),
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: useCacheKeyMergeHandler,
        }),
        fetchClientAuthMicroserviceEvents: builder.query({
            query: (props) => buildEventsQuery(props),
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: useCacheKeyMergeHandler,
        }),
    })
});

export const {
    useFetchClientLoginEventsQuery,
    useLazyFetchClientLoginEventsQuery,
    useFetchClientAuthMicroserviceEventsQuery,
    useLazyFetchClientAuthMicroserviceEventsQuery,
} = clientAuthEventEndpoints;